import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import styles from './Button.module.scss';


const Button = ({
  type,
  label,
  to,
  link,
  fullWidth,
  disabled,
  loading,
  center,
  secondary,
  onClick,
  history,
}) => {
  const buttonStyles = [
    styles.button,
    fullWidth && styles.fullWidth,
    disabled && styles.disabled,
    loading && styles.loading,
    center && styles.center,
    secondary && styles.secondary,
  ].join(' ');

  const handleClick = (e) => {
    if (to) {
      history.push(to);
    } else if (link) {
      window.open(link, '_blank');
    } else {
      onClick && onClick(e);
    }
  };

  return (
    <button
      className={buttonStyles}
      type={type}
      disabled={disabled || loading}
      onClick={(type === 'submit' || disabled || loading) ? null : handleClick}
    >
      {!loading && <span className={styles.label}>{label}</span>}
    </button>
  );
};

Button.propTypes = {
  label: PropTypes.string.isRequired,
  link: PropTypes.string,
  to: PropTypes.string,
  type: PropTypes.oneOf(['submit', 'reset', 'button']),
  fullWidth: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  center: PropTypes.bool,
  secondary: PropTypes.bool,
};

Button.defaultProps = {
  link: null,
  to: null,
  type: 'button',
  fullWidth: false,
  disabled: false,
  loading: false,
  center: false,
  secondary: false,
};

export default withRouter(Button);
